
import { Component, Vue } from 'vue-property-decorator'
import { makeComputedBinding } from 'shared/util'
import codes from 'iso-language-codes'
import { Erg } from 'shared/state/Erg'

export const defaultLanguages = [
			{
				label: 'English',
				value: 'en-US'
			},
			{
				label: 'English (UK)',
				value: 'en-GB'
			},
			{
				label: 'Deutsch',
				value: 'de'
			},
			{
				label: 'Español',
				value: 'es'
			},
						{
				label: 'Français',
				value: 'fr'
			},
						{
				label: 'Italiano',
				value: 'it'
			},
			{
				label: '日本語',
				value: 'ja'
			},
			{
				label: '한국어',
				value: 'ko'
			},
			{
				label: 'Nederlands',
				value: 'nl'
			},
						{
				label: 'Português',
				value: 'pt'
			},
			{
				label: 'Svenska',
				value: 'sv'
			},
			{
				label: '中文（简体）',
				value: 'zh'
			},
			{
				label: '中文（繁體）',
				value: 'zh-Hant'
			},
		]
export const languageCodes = codes

@Component
export class LanguageModule extends Vue {
	private supportedLanguages: any[] = defaultLanguages

	get list(): any {
		this.supportedLanguages = defaultLanguages
		/**
		 * Instead of using Erg.supportedLanguages, we will use the defaultLanguages array defined above.
		 * The following code is commented out because it was previously used to populate supportedLanguages
		 * based on Erg.supportedLanguages, but now we are using a predefined list of languages.,
		 */
		// Erg.supportedLanguages.forEach( f => {
		// 	const n = f.split('.', 1)[0].toString()
		// 	const c = codes.filter(cd => cd.iso639_1 === n)
		// 	if(c.length) {
		// 		this.supportedLanguages.push({label:c[0].name, value: n})
		// 	}
		// })
		return this.supportedLanguages
	}
}

export const Languages = new LanguageModule()
